<template>
  <div>

     <div v-if="loading">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
    </div>
   
    <b-row v-if="!loading">
      <b-col>
       
          <div class="row">
            <div class="col" v-if="user.image">
              <v-lazy-image
                :src="user.image?user.image.large:'null'"
                class="rounded-circle"
                width="80"
              />
            </div>
            <div class="col-12">
              <h3 class="mb-0 mt-3 text-body">{{ user.name }}</h3>

              <p class="mb-3 text-muted">{{ user.email }}</p>

              <p class="text-muted font-size-13 mb-1">Roles</p>
              <button
                v-for="item in user.roles"
                :key="item.id"
                class="btn mr-1 mb-1 btn-warning"
              >{{ item.name }}</button>

              <p class="text-muted font-size-13 mb-1 mt-3">Id</p>
              <p class="mb-3 text-body">{{ user.id }}</p>

              <p class="text-muted font-size-13 mb-1 mt-3">Created On</p>
              <p class="mb-3 text-body">{{ moment(new Date(user.created_at)).format("DD MMM YYYY, HH:mm:ss") }}</p>
            </div>
          </div>
     
      </b-col>
    </b-row>
  </div>
</template>

<script>
import userRepo from "@/api/repos/userRepo";

export default {
  props: ["id"],

  mounted() {
    this.getUser();
  },



  data() {
    return {
      loading: false,
      user: {}
    };
  },

  methods: {
    async getUser() {
      try {
        this.loading = true
        let { data } = await userRepo.get(this.id);
        this.user = data.user;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false
      }
    }
  }
};
</script>
